import { useStore } from '@store/index';
import { normalizeEmail } from '@utils/validation';
import { useMemo } from 'react';

/**
 * Custom hook to determine if the current user is a 100ms user.
 *
 * 100ms users are identified by email addresses from:
 * - @100ms.live domain
 * - @100ms.ai domain
 * - mailosaur.net domain (for testing)
 *
 * @returns {boolean} true if user is a 100ms user, false otherwise
 */
export const useIs100msUser = (): boolean => {
  const { user } = useStore();

  const is100msUser = useMemo(() => {
    if (!user?.email) {
      return false;
    }

    const email = normalizeEmail(user.email);
    const allowedDomains = ['@100ms.live', '@100ms.ai', 'mailosaur.net'];

    // Check if email ends with any of the allowed domains
    return allowedDomains.some(domain => email.endsWith(domain));
  }, [user?.email]);

  return is100msUser;
};
